import React from 'react';
import {TableCell, Typography} from '@mui/material';
import {KeySnapshot} from '../../api/Model';
import {TableColumnData} from "../data-table/TableColumnData";
import {DataTable} from "../data-table/DataTable";
import {KeyLocationShield, toLocationTypeEnum} from "../location/KeyLocationShield";
import {SetState} from "../../util/FormHandlers";

const columns: TableColumnData<KeySnapshot>[] = [
    {
        key: 'keyNumber',
        header: 'Key Number',
        width: '10em',
        cell: keyState => <TableCell><Typography variant="subtitle1">{keyState.key.keyNumber}</Typography></TableCell>,
    },
    {
        key: 'location',
        header: 'Current Location',
        width: '20em',
        cell: keyState => <TableCell><KeyLocationShield location={keyState.historyRecord.location}/></TableCell>,
    },
    {
        key: 'from',
        header: 'From',
        width: '8em',
        cell: keyState => <TableCell>{keyState.historyRecord.from || '—'}</TableCell>,
    },
    {
        key: 'exp-to',
        header: 'Expected',
        width: '8em',
        cell: keyState => <TableCell>{
            toLocationTypeEnum(keyState.historyRecord.location).expectedReturnDate || '—'
        }</TableCell>,
    },
    {
        key: 'notes',
        header: 'Notes',
        cell: keyState => <TableCell>{keyState.historyRecord.notes}</TableCell>,
    },
];

export function KeySelectTable({keys, selectedKeys, setSelectedKeys}: {
    keys: KeySnapshot[],
    selectedKeys: Set<KeySnapshot>,
    setSelectedKeys: SetState<Set<KeySnapshot>>,
}) {
    return (
        <DataTable
            columns={columns}
            rows={keys}
            id={key => `${key.key.id}-${key.historyRecord.id}`}
            selectedRows={selectedKeys}
            setSelectedRows={setSelectedKeys}
        />
    );
}
